import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

new Vue({
  vuetify: new Vuetify({ 
    theme: { 
      dark: false,
      themes: {
        light: {
          background: '#ffffff',
          surface: '#ffffff'
        }
      }
    } 
  }),
  router,
  render: h => h(App)
}).$mount('#app')